import { useState, useEffect } from 'react';
import DoctorPanel from './Panel';
import DoctorViewPanel from './DoctorView';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from '../../../../../api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
//Toast
import { ToastContainer, toast } from 'react-toastify';
import ToastMessage from '../../../../common/ToastMessage';
import 'react-toastify/dist/ReactToastify.css';

const DoctorFilterPanel = ({
  label,
  updateSelectedItemCount,
  selectedItemsData = [],
  editAffiliatedRecords,
  onDeleteSelectedDoctor,
  setSelectedItemsData,
  isContinueClicked,
  nextStep,
  handleValChange,
}) => {
  const cacheBuster = (url) => `${url}?cb=${Date.now()}`;
  let DoctorListResponse = null;
  let DoctorListDataResponse = null;

  const [selectedAllDoctorsOfSameNPI, setSelectedAllDoctorsOfSameNPI] =
    useState([]);

  const onSelectedDoctorsHandler = (selectedDoctorsList) => {
    setSelectedItemsData(selectedDoctorsList);
  };

  const onTrashButtonClickHandler = (doctorId, NPI) => {
    onDeleteSelectedDoctor(doctorId);
    setSelectedAllDoctorsOfSameNPI(
      selectedAllDoctorsOfSameNPI.filter((item) => item !== NPI),
    );
  };

  const removeDuplicateObj = (selectedDoctorsArr) => {
    const uniqueDoctors = [];
    const filetredObj = selectedDoctorsArr.filter((element) => {
      const isDuplicate = uniqueDoctors.includes(element.ConnectorID);
      if (!isDuplicate) {
        uniqueDoctors.push(element.ConnectorID);

        return true;
      }

      return false;
    });
    return filetredObj;
  };

  const getDoctorListWithSameNPI = async (NPI) => {
    try {
      //console.log( 'getDoctorListWithSameNPI NPI', NPI );
      let tempSelectedDoctors = [];
      DoctorListResponse = await axiosInstance.get(
        cacheBuster(
          APIEndpoints.getDoctorsListResources() +
            'pagenumber/1/pagesize/5000/npi/' +
            NPI,
        ),
      );
      DoctorListDataResponse = DoctorListResponse.data;

      if (
        DoctorListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        const selectedDoctorsLength = selectedItemsData.filter(
          (item) => item.NationalProviderId === NPI,
        ).length;
        const doctorsResponseLength =
          DoctorListDataResponse.Response.PhysicianViewDetails.length;
        const addedRecordsCount = doctorsResponseLength - selectedDoctorsLength;
        tempSelectedDoctors = removeDuplicateObj([
          ...selectedItemsData,
          ...DoctorListDataResponse.Response.PhysicianViewDetails,
        ]);

        setSelectedItemsData(tempSelectedDoctors);
        setSelectedAllDoctorsOfSameNPI([...selectedAllDoctorsOfSameNPI, NPI]);
        toast.success(
          <ToastMessage
            type="info"
            subTitle={`${
              addedRecordsCount > 0 ? addedRecordsCount : 0
            } Doctor(s) got added with same NPI`}
          />,
        );
      }
    } catch (error) {
      console.log('error', error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle={'Error Occured while adding the doctors with same NPI'}
        />,
      );
    }
  };

  const onAddAllRecordsSameNPI = (NPI) => {
    getDoctorListWithSameNPI(NPI);
  };

  useEffect(() => {
    updateSelectedItemCount(selectedItemsData.length);
  }, [selectedItemsData.length]);

  useEffect(() => {
    if (isContinueClicked) {
      //Added to reset/empty facilities selection - Start
      const tempObj = {
        facilities: [],
        selectedDoctorsByFacility: {},
      };
      const event = { target: { name: 'providerDetails', value: tempObj } };
      handleValChange(event);
      //Added to reset/empty facilities selection - End
      nextStep();
    }
  }, [isContinueClicked]);

  const sortedSelectedItemsData =
    selectedItemsData &&
    selectedItemsData.sort((a, b) => {
      return a.NationalProviderId - b.NationalProviderId;
    });

  return (
    <>
      <DoctorPanel
        label={label}
        onSelectedDoctorsHandler={onSelectedDoctorsHandler}
        selectedItemsData={selectedItemsData}
        editAffiliatedRecords={editAffiliatedRecords}
        selectedAllDoctorsOfSameNPI={selectedAllDoctorsOfSameNPI}
        setSelectedAllDoctorsOfSameNPI={setSelectedAllDoctorsOfSameNPI}
      />
      <div className="mt-2">
        <DoctorViewPanel
          selectedDoctors={sortedSelectedItemsData}
          onTrashButtonClickHandler={onTrashButtonClickHandler}
          editAffiliatedRecords={editAffiliatedRecords}
          onAddAllRecordsSameNPI={onAddAllRecordsSameNPI}
          selectedAllDoctorsOfSameNPI={selectedAllDoctorsOfSameNPI}
        />
      </div>
      <div className="toastify">
        <ToastContainer
          position="top-center"
          className="toastcontainer"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

export default DoctorFilterPanel;
